var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"section",staticClass:"tray-section"},[_c('div',{staticClass:"tray-section-heading"},[_c('a',{on:{"click":function($event){$event.preventDefault();_vm.toggle($event)}}},[_c('span',{class:[
          'af-icons',
          'af-icons-chevron-' + (_vm.isOpen ? 'down' : 'up'),
          'pull-left'
        ]}),_vm._v("\n       \n      "+_vm._s(_vm.title)+"\n    ")])]),_vm._v(" "),_c('collapsible',[(_vm.isOpen)?_vm._t("default"):_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }